import { Component, effect, input, model, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsModule } from 'src/app/ui/icons/icons.module';
import { MatTooltip } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-e-signing-canvas-toolbar',
	imports: [CommonModule, IconsModule, MatTooltip, FormsModule],
	templateUrl: './e-signing-canvas-toolbar.component.html',
})
export class ESigningCanvasToolbarComponent {
	percentage = model.required<number>();
	maxPercentage_ = input.required<number>();
	minPercentage_ = input.required<number>();
	zoomIn = output<void>();
	zoomOut = output<void>();
	maxLength = 4;
	minLength = 1;
	validPattern = '\\d+';
	inputModel_ = signal<string>('');

	constructor() {
		effect(() => this.inputModel_.set(this.percentage().toString()));
	}

	public onKeyPress(event: KeyboardEvent) {
		if (!/\d/.test(event.key)) {
			event.preventDefault();
		} else {
			this.inputModel_.set((event.target as HTMLInputElement).value);
		}
	}

	public setPercentage(target: HTMLInputElement) {
		if (
			target.checkValidity() &&
			target.value &&
			this.validatePercentage(target.value)
		) {
			this.percentage.set(Number(target.value));
		} else {
			this.inputModel_.set(this.percentage().toString());
		}
	}

	private validatePercentage(value: string): boolean {
		const numValue = Number(value);
		return (
			!isNaN(numValue) &&
			numValue >= this.minPercentage_() &&
			numValue <= this.maxPercentage_()
		);
	}
}
